/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Toggle_Caption_LockInputs */



/**
* | output |
* | --- |
* | "Toggle Caption Lock" |
*
* @param {Shortcut_Keys_Name_Toggle_Caption_LockInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_toggle_caption_lock = /** @type {((inputs?: Shortcut_Keys_Name_Toggle_Caption_LockInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Toggle_Caption_LockInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Basculer verrouillage des sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertitel-Sperre ein-/ausschalten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attiva/disattiva blocco didascalia")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Включить/Выключить блокировку субтитров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Activar o desactivar el bloqueo de subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("切换字幕锁定")
	if (locale === "ja") return /** @type {LocalizedString} */ ("キャプションロックを切り替える")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कैप्शन लॉक टॉगल करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ativar/Desativar Bloqueio de Legendas")
	return /** @type {LocalizedString} */ ("Toggle Caption Lock")
});